
export type StringPredicate = (text: string) => boolean;

export function pascalize(text: string) {
  return text
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter) {
      return letter.toUpperCase()
    })
    .replace(/\s+/g, "")
}
